import {
	serviceGetFilters,
	serviceGetTalk,
	serviceGetTalks,
} from '@services/Services';
import getAvailableTerms from './get-avaliable-terms';

// Define the getAllTalks function
const getAllTalks = async (dispatch, setLoading, setError, retries = 3) => {
	try {
		const response = await serviceGetTalks();
		const data = await response.data;
		if (data.hasOwnProperty('data')) {
			dispatch({
				type: 'SET_ALL_TALKS',
				payload: data.data.items,
			});
		}
		setError(null);
	} catch (error) {
		if (retries > 0) {
			setTimeout(() => {
				getAllTalks(setLoading, setError, retries - 1);
			}, 1000);
		}
		setError(error);
	} finally {
		setLoading(false);
	}
};

// Define the getFilters function
const getFilters = async (dispatch, setError, retries = 3) => {
	try {
		const response = await serviceGetFilters();
		const data = await response.data;

		if (data.hasOwnProperty('data')) {
			// Set the filters in the state
			dispatch({
				type: 'SET_FILTERS',
				payload: {
					default: data.data?.default ? data.data.default : {},
					days: data.data?.days ? data.data.days : [],
					venues: data.data?.venues ? data.data.venues : [],
					categories: data.data?.categories
						? data.data.categories
						: [],
					tags: data.data?.tags ? data.data.tags : [],
					allowedCategories: data.data?.allowed_categories
						? data.data.allowed_categories
						: [],
					allowedTags: data.data?.allowed_tags
						? data.data.allowed_tags
						: [],
				},
			});
		}

		setError(null);
	} catch (error) {
		if (retries > 0) {
			setTimeout(() => {
				getFilters(retries - 1);
			}, 1000);
		}
		setError(error);
	}
};

// Define the getFilteredTalks function
const getFilteredTalks = (dispatch, allTalks, talkFilters = { query: [] }) => {
	// Filter allTalks based on taxonomy term_id

	const filteredTalks = allTalks.filter((talk) => {
		const { taxonomies = { days: [], venues: [], categories: [] } } = talk;

		// Create an array of term_id
		const days = taxonomies.days?.length
			? taxonomies.days.map((day) => day.term_id)
			: [];
		const venues = taxonomies.venues?.length
			? taxonomies.venues.map((venue) => venue.term_id)
			: [];

		// Find the index of the object in talkFilters.query array where the taxonomy is talk_day
		const dayFilterIndex = talkFilters.query.findIndex(
			(item) => item.taxonomy === 'talk_day',
		);

		// Find the index of the object in talkFilters.query array where the taxonomy is talk_venue
		const venueFilterIndex = talkFilters.query.findIndex(
			(item) => item.taxonomy === 'talk_venue',
		);

		/**
		 * Start filtering
		 */
		let hasDay = false;
		let hasVenue = false;
		let hasVenueFilter = false;

		// If the dayIndex is not -1, then we have a talk_day in the query
		if (dayFilterIndex !== -1) {
			// If the term_id of the talk_day in the query is not in the days array, then return false
			if (days.includes(talkFilters.query[dayFilterIndex].term_id)) {
				hasDay = true;
			}
		}

		// If the venueIndex is not -1, then we have a talk_venue in the query
		if (venueFilterIndex !== -1) {
			hasVenueFilter = true;
			// If the term_id of the talk_venue in the query is not in the venues array, then return false
			if (venues.includes(talkFilters.query[venueFilterIndex].term_id)) {
				hasVenue = true;
			}
		}

		let output = false;

		// If we have a day match but no venue
		if (hasDay && !hasVenueFilter) {
			output = talk;
			// If we have a day match and a venue match
		} else if (hasDay && hasVenueFilter && hasVenue) {
			output = talk;
		}

		return output;
	});

	// Set the filteredTalks in the state
	dispatch({
		type: 'SET_FILTERED_TALKS',
		payload: filteredTalks,
	});
};

// Define the getTalkById function
const getTalkById = async (setLoading, setError, talkId) => {
	let talk = [];

	try {
		const response = await serviceGetTalk(talkId);
		const data = await response.data;
		if (data.hasOwnProperty('data')) {
			if (data?.data) {
				talk = data.data;
			}
		}
		setError(null);
	} catch (error) {
		setError(error);
	} finally {
		setLoading(false);
	}

	return talk;
};

export {
	getAllTalks,
	getFilters,
	getFilteredTalks,
	getTalkById,
	getAvailableTerms,
};
